export function OutlineIdIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.08 6H4.92C3.85961 6 3 6.85961 3 7.92V17.0784C3 18.1388 3.85961 18.9984 4.92 18.9984H19.08C20.1404 18.9984 21 18.1388 21 17.0784V7.92C21 6.85961 20.1404 6 19.08 6Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M12.9985 9.99805H17.0017"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M14.0015 14.002H17.0015"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.50066 10.9964C8.77637 10.9964 8.99986 10.7729 8.99986 10.4972C8.99986 10.2215 8.77637 9.99805 8.50066 9.99805C8.22496 9.99805 8.00146 10.2215 8.00146 10.4972C8.00146 10.7729 8.22496 10.9964 8.50066 10.9964Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.50071 14.002C9.60471 14.002 10.4975 14.8948 10.4975 15.9988H6.50391C6.50391 14.8948 7.39671 14.002 8.50071 14.002Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
